import { z } from 'zod';
import { requiredFieldSchema } from './fields';

export const postLocationSchema = (t) =>
  z.object({
    name: requiredFieldSchema(t('error.locationNameRequired')),
    description: requiredFieldSchema(t('error.locationDescrRequired')),
  });
